__turbopack_context__.v({
  "container": "hGX9XW_container",
  "container-img": "hGX9XW_container-img",
  "content-text": "hGX9XW_content-text",
  "image": "hGX9XW_image",
  "title-eyebrow": "hGX9XW_title-eyebrow",
});
